<template>
    <span class="table-search-container">
        <template v-for="fields in datadicInfo.fields">
            <template v-if="fields.searchable">
                <el-input v-if="fields.widgetType === 'SingleLineText'" v-model="query[fields.name]" :key="fields.name" :placeholder="fields.label" :maxlength="fields.maxLength" :minlength="fields.minLength" size="mini" @change="submit" />
                <el-select v-else-if="fields.widgetType === 'DropdownSelect' " v-model="query[fields.name]" size="mini" :key="fields.name" @change="submit" clearable :placeholder="fields.label">
                    <el-option :label="'请选择'+fields.label" key value></el-option>
                    <el-option v-for="o in fields.options" :key="o.value ||o.id" :label="o.name" :value="o.value || o.id"></el-option>
                </el-select>
                <!-- Date -->
                <el-date-picker v-else-if="fields.widgetType === 'Date' " size="mini" v-model="query[fields.name]" type="date" :key="fields.name" @change="submit" :placeholder="fields.label" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                <!-- DateTime -->
                <el-date-picker v-else-if="fields.widgetType === 'DateTime' " size="mini" v-model="query[fields.name]" type="datetime" :key="fields.name" @change="submit" :placeholder="fields.label"></el-date-picker>
                <!-- Time -->
                <el-time-picker v-else-if="fields.widgetType === 'Time' " size="mini" v-model="query[fields.name]" @change="submit" :key="fields.name" :placeholder="fields.label"></el-time-picker>
            </template>
        </template>
    </span>
</template>
<script>
import DatadicAPI from "@/web-framework/api/datadic.js";
export default {
    name: "TableSearch",
    props: ["value", "module"],
    data() {
        return {
            query: {},
            isHerit: false,
            service: '',
            datadicName: '',
            datadicInfo: '',
        };
    },
    watch: {
        value(value) {
            Vue.set(this, "query", value);
        }
    },
    mounted() {
        let p = this.module.split('/');
        this.service = p[1];
        this.datadicName = p[2];
        Vue.set(this, "query", this.value);
        this.loadDatadic();
    },
    methods: {
        loadDatadic() {
            DatadicAPI.getDatadic(this.service, this.datadicName).then(result => {
                if (result.success) {
                    this.datadicInfo = result.data.datadicInfo;
                }
            });
        },
        submit() {
            this.$emit("input", this.query);
        }
    },
};
</script>
<style lang="less" scoped>
.table-search-container {
    /deep/.el-input {
        width: auto;
        min-width: 100px;
        margin-bottom: 10px;
    }

    /deep/.el-date-editor,
    /deep/.el-input {
        margin-right: 6px;
    }
}
</style>